import { type ComponentProps } from 'react';
import { Spinner } from '../admin/spinner';

type CenteredSpinnerProps = {
  size?: ComponentProps<typeof Spinner>['size'];
};

/** A teal spinner centred in its parent. */
export const CenteredSpinner = ({ size = 'large' }: CenteredSpinnerProps) => (
  <div className="flex size-full items-center justify-center">
    <Spinner size={size} />
  </div>
);
